import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { MedicalConditionContext, MedicalConditionModalComponent } from '../../../customer/medical/customer-condition-modal.component';
import { CustomerIndividualMedicalCondition } from '../../../customer/models/customer-individual-medical-condition.model';
import { CustomerManageService } from '../../../customer/shared/customer-manage.service';
import { ModalSize } from '../../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';

export class SelectConditionsViewModel extends CustomerIndividualMedicalCondition {
    public formGroup: UntypedFormGroup;
}

@Component({
    selector: 'select-conditions',
    templateUrl: './select-conditions.html',
    inputs: ['isReadOnly']
})
export class SelectConditionsComponent implements OnInit {
    @Input() public customerNumberId: number;
    @Input() public runValidation = true;
    @Input() public selectConditionControl: string;
    @Input() public required = false;
    public conditions: SelectConditionsViewModel[];

    private conditionsForm: UntypedFormArray;
    private associatedConditionIds: number[];

    public isReadOnly = false;

    constructor(
        public formDirective: FormGroupDirective,
        private modalService: MvdModalService,
        private formBuilder: UntypedFormBuilder,
        private customerService: CustomerManageService
    ) {
        this.associatedConditionIds = [];
    }

    public ngOnInit() {
    }

    public ngAfterViewInit(){
        if ((null == this.selectConditionControl) || ('' == this.selectConditionControl.trim())) {
            this.selectConditionControl = 'conditions';
        }
        this.loadConditions();
    }

    public getSelectedConditionIds = (): number[] => {
        let conditionIds = [];

        if (null != this.conditionsForm) {
            for (let i = 0; i < this.conditionsForm.length; i++) {
                let c = this.conditionsForm.at(i);

                if (true == c.get('selected').value) {
                    conditionIds.push(+c.get('conditionId').value);
                }
            }
        }

        return conditionIds;
    };

    public selectConditions = (conditionIds: number[]): void => {
        if ((null != conditionIds) && (null != this.conditionsForm) && (0 != this.conditionsForm.length)) {
            for (let i = 0; i < this.conditionsForm.length; i++) {
                let control = this.conditionsForm.at(i);
                let id = control.get('conditionId').value;
                control.get('selected').setValue(true == conditionIds.includes(id));
            }
        } else {
            this.associatedConditionIds = conditionIds;
        }
    };

    public loadConditions = (): void => {
        if (null == this.formDirective) {
            console.error('Form required');
            return;
        }

        let form = this.formDirective.form;

        if (null == form) {
            console.error('Form required');
            return;
        }

        this.conditionsForm = form.get(this.selectConditionControl) as UntypedFormArray;

        if ((null == this.conditionsForm) || (null == this.conditionsForm.value)) {
            this.conditionsForm = this.formBuilder.array([]);
            form.setControl(this.selectConditionControl, this.conditionsForm);
            if (this.runValidation) {
                this.conditionsForm.validator = this.atLeastOneConditionValidator;
                this.conditionsForm.updateValueAndValidity();
            }
        }
        while (0 != this.conditionsForm.length) {
            this.conditionsForm.removeAt(0);
        }

        this.customerService.getCustomerMedicalConditions(this.customerNumberId)
            .subscribe(r => {
                this.conditions = r.map(e => {
                    let c = <SelectConditionsViewModel> e;
                    let selectedInitialValue = false;

                    if (null != this.associatedConditionIds) {
                        selectedInitialValue = this.associatedConditionIds.some(i => i == e.id);
                    }

                    c.formGroup = this.formBuilder.group({
                        conditionId: [e.id],
                        selected: [selectedInitialValue]
                    });
                    this.conditionsForm.push(c.formGroup);

                    if (false == this.conditionsForm.enabled) {
                        c.formGroup.disable();
                    }

                    return c;
                });
            });
    };

    public editCondition = (customerMedicalConditionId?: number): void => {
        this.saveAssociatedConditionIds();
        let data = new MedicalConditionContext(this.customerNumberId, null, true, customerMedicalConditionId);
        this.modalService.open(MedicalConditionModalComponent, data, ModalSize.Medium)
            .afterClosed()
            .subscribe(() => this.loadConditions());
    };

    private saveAssociatedConditionIds = (): void => {
        this.associatedConditionIds = [];

        if (null != this.conditionsForm) {
            for (let i = 0; i < this.conditionsForm.length; i++) {
                let condition: any = this.conditionsForm.at(i);

                if (true == condition.get('selected').value) {
                    this.associatedConditionIds.push(+condition.get('conditionId').value);
                }
            }
        }
    };

    private atLeastOneConditionValidator = (control: AbstractControl): any => {
        let array = control as UntypedFormArray;

        if (array.controls.some(e => true == e.get('selected').value)) {
            return null;
        }

        return { 'conditionRequired': true };
    };
}
